// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FriendsNew from '../_raw/service/icon_friends_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FriendsNew);
